import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/travis/build/gramps-graphql/gramps/docs/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`To make development easier, GrAMPS provides a CLI.`}</p>
      <p>{`The CLI is designed to make three things easier:`}</p>
      <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Running Local Data Sources</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Developing Custom Gateways</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Developing Offline</AnchorLink>
      </AnchorLinks>
      <blockquote>
        <p parentName="blockquote"><strong parentName="p">{`IMPORTANT:`}</strong>{` The GrAMPS CLI starts a gateway `}<em parentName="p">{`for development only`}</em>{`. It has not been tested in production, and isn’t intended to be used outside of local development.`}</p>
      </blockquote>
    </PageDescription>
    <h2 {...{
      "id": "running-local-data-sources"
    }}>{`Running Local Data Sources`}</h2>
    <p>{`A primary focus of GrAMPS is on the development experience. To that end, we want to make it as painless as possible to start working on a new data source.`}</p>
    <p>{`Thanks to the CLI, you can create and run your own data source in about 60 seconds using just four quick commands:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`# Get a copy of the data source base without the git history
npx graphql-cli create -b gramps-graphql/data-source-base data-source-mydata && cd $_

# Start a gateway and start developing!
yarn dev
`}</code></pre>
    <p>{`And that’s it!`}</p>
    <h2 {...{
      "id": "developing-custom-gateways"
    }}>{`Developing Custom Gateways`}</h2>
    <p>{`In a real project, a GraphQL gateway will likely include multiple data sources. For example, you might have a gateway with three data sources:`}</p>
    <ul>
      <li parentName="ul">{`User`}</li>
      <li parentName="ul">{`Product`}</li>
      <li parentName="ul">{`WishList`}</li>
    </ul>
    <p>{`Let’s assume WishList depends on both User and Product.`}</p>
    <p>{`Assuming the start script for the gateway is `}<inlineCode parentName="p">{`server.js`}</inlineCode>{`, we can use the CLI to start the gateway like so:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`gramps dev --gateway ./server.js
`}</code></pre>
    <p>{`But what if we need to make changes to WishList? Not to worry: GrAMPS has you covered. Simply run the gateway and specify the path to your local data source:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`gramps dev --gateway ./server.js --data-source ../data-source-wishlist
`}</code></pre>
    <p>{`GrAMPS is smart enough to recognize that the local WishList data source should override the one that’s installed in the gateway, so you can develop your data source in the context where it will be deployed.`}</p>
    <h2 {...{
      "id": "developing-offline"
    }}>{`Developing Offline`}</h2>
    <p>{`Nothing is worse than losing a half day of work because the back-end is down.`}</p>
    <p>{`Fortunately, GraphQL makes it really easy to `}<a parentName="p" {...{
        "href": "https://www.apollographql.com/docs/graphql-tools/mocking.html"
      }}>{`mock your data`}</a>{`, and GrAMPS allows you to enable mock data using the CLI:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`# Develop a data source locally with mock data.
gramps dev --data-source ./data-source-test --mock

# Develop using your custom gateway with mock data.
gramps dev --gateway ./server.js --mock
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      